export const easy = 'easy' 
export const medium = 'medium'
export const hard = 'hard'